import type { ImageSourcePropType } from "react-native";

const THERAPY_ILLUSTRATIONS: Record<string, ImageSourcePropType> = {
  "therapy-acupuncture": require("./candle.png"),
  "therapy-chinese-herbal-medicine": require("./leaf.png"),
  "therapy-mbsr": require("./zen-garden.png"),
  "therapy-yoga": require("./monstera.png"),
  "therapy-cbt": require("./brain.png"),
  "therapy-endometrial-scratching": require("./uterus.png"),
  "therapy-assisted-hatching": require("./egg.png"),
  "therapy-embryo-glue": require("./glue-stick.png"),
  "therapy-time-lapse": require("./electron-microscope.png"),
  "therapy-calcium-ionophore": require("./serum.png"),
  "therapy-advanced-sperm-selection": require("./electron-microscope.png"),
  "therapy-prp-ovarian": require("./serum.png"),
  "therapy-intralipid": require("./iv-drip-bag.png"),
  "therapy-gcsf-uterine-infusion": require("./uterus.png"),
  "therapy-reproductive-immunology": require("./iv-drip-bag.png"),
  "therapy-elective-freeze-all": require("./hourglass-timer.png"),
  "therapy-intrauterine-culture": require("./uterus.png"),
  "therapy-intrauterine-hcg": require("./iv-drip-bag.png"),
  "therapy-endometrial-priming-addons": require("./moon.png"),
  "therapy-growth-factor-culture-medium": require("./glue-stick.png"),
  "therapy-icsi-non-male-factor": require("./egg.png"),
  "therapy-ovarian-stimulation-adjuncts": require("./serum.png"),
  "therapy-duostim": require("./hourglass-timer.png"),
  "therapy-ivm": require("./egg.png"),
  "therapy-experimental-rejuvenation": require("./sprout.png"),
  "therapy-pelvic-floor": require("./massage.png"),
  "therapy-fertility-massage": require("./sauna-blanket.png"),
  "therapy-mediterranean-diet": require("./salad.png"),
  "therapy-anti-inflammatory-diet": require("./smoothie-bowl.png"),
  "therapy-sleep-optimization": require("./moon.png"),
  "therapy-toxin-reduction": require("./sprout.png"),
};

export default THERAPY_ILLUSTRATIONS;
